import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import BoatRVParking from './pages/BoatRVParking';
import BoatRVStorage from './pages/BoatRVStorage';
import BusinessStorage from './pages/BusinessStorage';
import CommercialYardStorage from './pages/CommercialYardStorage';
import SizeGuide from './pages/SizeGuide';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import TipsRules from './pages/TipsRules';
import TenantProtection from './pages/TenantProtection';
import StorageVanAlstyne from './pages/StorageVanAlstyne';
import StorageWhitewright from './pages/StorageWhitewright';
import NotFound from './pages/NotFound';

// Scroll position on navigation. React Router keeps the current scroll
// offset when the path changes, so a header link clicked from the bottom of
// one page opens the next one already scrolled down — a plain route change
// therefore starts at the top. Links carrying a #hash (Specials -> People
// Who Serve) do not scroll by themselves, so those are aimed explicitly:
// re-aim through a short schedule, because a single timed
// scroll lands short because images above the target load late and grow
// the page underneath it. Cancels if the reader scrolls themselves.
function ScrollOnNavigate() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      // 'instant', not the default: App.css sets scroll-behavior: smooth,
      // so a plain scrollTo animates the whole page back up and the new
      // route appears to hang while it does.
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      return undefined;
    }
    const id = hash.slice(1);
    let done = false;
    const stop = () => { done = true; };
    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('touchmove', stop, { passive: true });
    const timers = [60, 250, 600, 1000, 1600].map((ms, i) =>
      setTimeout(() => {
        if (done) return;
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: i === 0 ? 'smooth' : 'auto', block: 'start' });
      }, ms)
    );
    return () => {
      done = true;
      timers.forEach(clearTimeout);
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchmove', stop);
    };
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <ScrollOnNavigate />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/boat-rv-parking-bells" element={<BoatRVParking />} />
          <Route path="/boat-rv-storage-bells" element={<BoatRVStorage />} />
          <Route path="/business-storage-bells" element={<BusinessStorage />} />
          <Route path="/commercial-yard-storage-bells" element={<CommercialYardStorage />} />
          <Route path="/storage-sizes" element={<SizeGuide />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/tips-rules" element={<TipsRules />} />
          <Route path="/tenant-protection" element={<TenantProtection />} />
          <Route path="/storage-van-alstyne-tx" element={<StorageVanAlstyne />} />
          <Route path="/storage-whitewright-tx" element={<StorageWhitewright />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;